import React from "react";
import PropTypes from "prop-types";

const AccountSection = ({ title, children: fields }) => {
  return (
    <div className="section">
      <h3 className="section-title">{title}</h3>
      {fields}
    </div>
  );
};

AccountSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.object,
};

export default AccountSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/formSections/AccountSection.js